'use client'

import { useMemo, useState } from 'react'

import { NOTIFICATION_DRAWER_FILTER } from '../const/notification-drawer-filter.const'
import type { Notification } from '../types/notification.type'
import type { NotificationDrawerFilter } from '../types/notification-drawer-filter.type'
import { filterNotificationsByReadState } from '../utils/filterNotificationsByReadState'
import { sortNotificationsBySeverity } from '../utils/sortNotificationsBySeverity'

type Params = {
  notifications: Notification[]
}

export function useNotificationDrawerFilters({ notifications }: Params) {
  const [filter, setFilter] = useState<NotificationDrawerFilter>(NOTIFICATION_DRAWER_FILTER.ALL)

  const filteredNotifications = useMemo(() => {
    const filtered = filterNotificationsByReadState(notifications, filter)
    return sortNotificationsBySeverity(filtered)
  }, [filter, notifications])

  return {
    filter,
    setFilter,
    filteredNotifications,
  }
}
